__turbopack_context__.v({
  "input": "multi-value-list-module__WgfNWG__input",
  "inputWrapper": "multi-value-list-module__WgfNWG__inputWrapper" + " " + __turbopack_context__.i(80492)["input"] + " " + __turbopack_context__.i(80492)["wrapper"],
  "item": "multi-value-list-module__WgfNWG__item",
  "list": "multi-value-list-module__WgfNWG__list",
  "listWrapper": "multi-value-list-module__WgfNWG__listWrapper",
  "valueTag": "multi-value-list-module__WgfNWG__valueTag",
  "valuesList": "multi-value-list-module__WgfNWG__valuesList",
  "wrapper": "multi-value-list-module__WgfNWG__wrapper",
});
